export default "__VITE_ASSET__BT$tXcdo__"